import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Rating } from '@/components/molecule/Rating';
interface ReviewSummaryProps {
  reviewRating?: number;
  reviewCount: number;
  className?: string;
}
export const ReviewSummary = t0 => {
  const $ = _c(23);
  const {
    reviewRating,
    reviewCount,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mb-8 flex flex-row items-center justify-center gap-20 rounded-small border border-Gray-200 bg-Gray-25 px-20 py-40", "mobile-tablet:mb-24 mobile-tablet:flex-col mobile-tablet:items-start mobile-tablet:gap-6 mobile-tablet:border-0 mobile-tablet:p-20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className={cn("font-500 text-Gray-600 typo-body1", "mobile-tablet:typo-body4")}>답례품 만족도</p>;
    t3 = <div className="h-32 w-1 border-l border-Gray-300 mobile-tablet:hidden" />;
    t4 = cn("flex items-center gap-4", "mobile-tablet:w-full");
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  const t5 = reviewRating ?? 0;
  let t6;
  if ($[5] !== t5) {
    t6 = <Rating value={t5} size={24} className="mr-16 mobile-tablet:mr-0" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("font-700 text-Gray-900 typo-h3", "mobile-tablet:typo-h5");
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = reviewRating ?? 0;
  let t9;
  if ($[8] !== t8) {
    t9 = t8.toFixed(1);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <p className={t7}>{t9}</p>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className={cn("font-500 text-Gray-500 typo-h5", "mobile-tablet:text-Gray-900 mobile-tablet:typo-body3")}>/5.0</p>;
    t12 = cn("font-400 text-Gray-600 typo-body2", "mobile-tablet:ml-auto mobile-tablet:typo-body4");
    $[12] = t11;
    $[13] = t12;
  } else {
    t11 = $[12];
    t12 = $[13];
  }
  let t13;
  if ($[14] !== reviewCount) {
    t13 = <p className={t12}>({reviewCount}개)</p>;
    $[14] = reviewCount;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t10 || $[17] !== t13 || $[18] !== t6) {
    t14 = <div className={t4}>{t6}{t10}{t11}{t13}</div>;
    $[16] = t10;
    $[17] = t13;
    $[18] = t6;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t1 || $[21] !== t14) {
    t15 = <div className={t1}>{t2}{t3}{t14}</div>;
    $[20] = t1;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
};